<template>
  <div class="auth-manager" :class="classObj">
    <AuthWidget
      v-if="user"
      :in-drawer="inDrawer"
      :hide-welcome="$core.breakpoint.lgAndDown"
    />

    <template v-else>
      <AppBtn
        class="auth-manager__btn"
        color="fourth"
        @click="handleLoginClick"
      >
        Вход&nbsp;/&nbsp;Регистрация
      </AppBtn>
    </template>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { showAlert } from "@/core/common/";
import AuthWidget from "./AuthWidget";

export default {
  name: "AuthManager",
  components: {
    AuthWidget
  },
  props: {
    inDrawer: Boolean
  },
  data() {
    return {
      hideRegistration: true
    };
  },
  computed: {
    ...mapGetters("auth", ["user"]),
    classObj() {
      return {
        "auth-manager_in-drawer": this.inDrawer
      };
    }
  },
  created() {
    this.dateWhenRegistrationOpens = this.$dayjs.tz(
      "2021-01-25 12:00",
      "Europe/Moscow"
    );
  },
  methods: {
    ...mapActions("auth", ["loginRB"]),
    handleLoginClick() {
      if (this.checkIsRegistrationOpened()) {
        this.loginRB();
      } else {
        const formattedDate = this.dateWhenRegistrationOpens.format(
          "DD MMMM в HH:mm (МСК)"
        );
        showAlert(`Регистрация станет доступной ${formattedDate}.`);
      }
    },
    checkIsRegistrationOpened() {
      return Date.now() > this.dateWhenRegistrationOpens.valueOf();
    }
  }
};
</script>

<style lang="scss">
.auth-manager {
  position: relative;
  width: 290px;
  flex-shrink: 0;
  margin-left: auto;
  display: flex;
  flex-direction: row-reverse;

  &__btn {
    height: 45px;
    text-transform: uppercase;
    font-size: 19px;
    font-weight: fw(bold);

    &:not(:last-child) {
      margin-right: 10px;
    }
  }

  @include breakpoint("xs-only") {
    width: 240px;
    &__btn {
      font-size: 16px;
    }
  }
}
</style>
